import React from "react";
import styles from "./index.module.scss";

type FilterPillsProps = {
  appliedFilters: any;
  totalData: number;
  handleRemoveFilter: (key: string, val: string) => void;
  handleClearAllFilters: () => void;
  onMoreClick?: () => void;
};

const FilterPills: React.FC<FilterPillsProps> = ({
  appliedFilters,
  totalData,
  handleRemoveFilter,
  handleClearAllFilters,
  onMoreClick, 
}) => {
  if (!appliedFilters || Object.keys(appliedFilters).length === 0) return null;

  // Flatten all pills for counting and rendering
  const allPills: { key: string; val: string }[] = [];
  Object.entries(appliedFilters).forEach(([key, value]) => {
    if (key === "dateRange" && value && value.startDate && value.endDate) {
      allPills.push({
        key: "dateRange",
        val: `${value.startDate} - ${value.endDate}`, // Only show the date range, no label
      });
    } else {
      const valuesArray = Array.isArray(value)
        ? value
        : typeof value === "object"
        ? [`${value.operator} ${value.value}`]
        : [value];
      valuesArray.forEach((val: string) => {
        allPills.push({ key, val });
      });
    }
  });

  const pillsToShow = allPills.slice(0, 5);
  const pillsHiddenCount = allPills.length - 5;

  // Custom remove handler for dateRange
  const handleRemove = (key: string, val: string) => {
    // Handle both key === "dateRange" and key === "" (for date range pill)
    if (key === "dateRange" || (key === "" && val && val.includes(" - "))) {
      handleRemoveFilter("dateRange", "");
    } else {
      handleRemoveFilter(key, val);
    }
  };

  return (
    <div className={styles.filterPillContainer}>
      <span className="styles.divider">|</span>
      <span className={styles.recordsFound}>{totalData} records found</span>
      <span className={styles.filtersLabel}>Filters applied:</span>
      {pillsToShow.map(({ key, val }, idx) => (
        <span key={`${key}-${idx}`} className={styles.filterPill}>
          {val}
          <button
            className={styles.removeFilterBtn}
            onClick={() => handleRemove(key, val)}
          >
            ×
          </button>
        </span>
      ))}
      {pillsHiddenCount > 0 && (
        <span
          className={styles.morePills}
          style={{ cursor: "pointer" }}
          onClick={onMoreClick}
        >
          +{pillsHiddenCount} more
        </span>
      )}
      <button className={styles.clearAllBtn} onClick={handleClearAllFilters}>
        clear all
      </button>
    </div>
  );
};

export default FilterPills;